import * as marietta from '../../..';
import { CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';

export default class StretchLineWallText {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot: marietta.core.Point) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot: marietta.core.Point) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    minVisibleDistance: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch * 0.25;

    textObj: SVGTextElement;

    textboxObj: SVGElement;

    public spt: SVGSprite;

    updateLine: Function;

    textBoxVisible: boolean = false;

    fontSize: number;

    textboxObjWidth: number;

    textboxObjHeight: number;

    textboxWidth: number;

    textboxHeight: number;

    textboxPadding: number;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite: SVGSprite, id: number) {
      this.textboxObjWidth = 45;
      this.textboxObjHeight = 18;
      this.textboxWidth = 43;
      this.textboxHeight = 16;
      this.fontSize = 12;
      this.textboxPadding = 8;

      const scale = marietta.webcad.WebCADGlobal.scaleSize;
      const fontSize = this.fontSize * (1 / scale);
      const textboxWidth = this.textboxWidth * (1 / scale);
      const textboxHeight = this.textboxHeight * (1 / scale);
      // ラインの作成

      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `line_text_${id}`);

      this.textObj = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      this.textObj.setAttribute('fill', '#000000');
      this.textObj.textContent = '0mm';
      viewObj.appendChild(this.textObj);

      this.textboxObj = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      this.textboxObj.setAttribute('height', (this.textboxObjHeight * (1 / scale) + (this.textboxPadding * scale)).toString());
      this.textboxObj.setAttribute('width', (this.textboxObjWidth * (1 / scale) + (this.textboxPadding * scale)).toString());
      const inpT = document.createElement('input');
      inpT.setAttribute('type', 'text');
      this.textboxObj.appendChild(inpT);
      this.textboxObj.setAttribute('id', 'wallGuideTextbox');
      this.textboxObj.setAttribute('class', 'wallGuideTextbox');
      viewObj.appendChild(this.textboxObj);
      inpT.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
      inpT.setAttribute('style', `font-size:${fontSize}px;width:${textboxWidth}px;height:${textboxHeight}px;`);
      inpT.addEventListener('keyup', this.changeDistance);
      inpT.addEventListener('keydown', this.downDistance);

      this.textObj.style.visibility = 'hidden';

      this.spt = new SVGSprite(viewObj);
      targetSprite.addChild(this.spt);
    }

    /**
     * Translateのアップデート
     * @param showInMM mmの表示切替
     */
    updateTransforms(showInMM: boolean = true) {
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;

      if (this.firstDot === undefined || this.secondDot === undefined) return;
      const centerPoint: marietta.core.Point = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
      const distance: number = marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(this.firstDot, this.secondDot));
      const num = marietta.webcad.util.WebCADUtil.sepThreeDigit(Math.round(distance));
      if (showInMM) {
        this.textObj.textContent = `${num}mm`;
      } else {
        this.textObj.textContent = num;
      }
      (<HTMLInputElement> this.textboxObj.children[0]).value = Math.round(distance).toString();

      const bound = this.textObj.getBoundingClientRect();
      this.textObj.setAttribute('x', (centerPoint.x - bound.width * (sc / 2)).toString());
      this.textObj.setAttribute('y', (centerPoint.y + bound.height * (sc / 2)).toString());

      const textPost = this.getTextBoxPosition();
      const textboxTransform = `matrix(1,0,0,1,${String(textPost.textX)},${String(textPost.textY)})`;
      this.textboxObj.setAttribute('transform', textboxTransform);

      this.spt.visible = this.minVisibleDistance < distance;
      this.spt.update();
      (<HTMLElement> this.textboxObj.firstElementChild).focus();
    }

    /**
     * textBoxの中心位置を計算する関数
     * @returns object
     */
    getTextBoxPosition() {
      const cp = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
      const bound = this.textboxObj.getBoundingClientRect();
      const { width } = bound;
      const { height } = bound;
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;
      const textX = cp.x - width * (sc / 2);
      const textY = cp.y - height * (sc / 2);
      return { textX, textY };
    }

    /**
     * 距離テキストボックスキーボードイベントトリガーの変更
     * @param event
     */
    changeDistance = (event: KeyboardEvent) => {
      if (event.keyCode === 27) { // ESCAPE
        // 屋根モードであれば、1点戻る
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOM) {
          // 最後の点をキャンセル
          (marietta.webcad.WebCADGlobal.itemManager.itemController as marietta.webcad.control.ItemControllerRoomPointInput).cancelPreviousDot();
          return;
        }
      }
      const validate = (e: any) => {
        const t = e.value;
        const ex = /^[0-9]+\.?[0-9]*$/;
        if (ex.test(t) === false) {
          e.value = t.substring(0, t.length - 1);
        } else {
          e.value = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)) : t;
          const x = parseFloat(t);
          if (Number.isNaN(x) || x < 0 || x > 100000) {
            e.value = t.substring(0, t.length - 1);
          }
        }
      };
      const target:HTMLInputElement = (<HTMLInputElement>event.currentTarget);
      validate(target);

      if (target.value === '') {
        target.style.border = 'solid 2px red';
      } else if (Number.isNaN(target.value) || parseFloat(target.value) < 0 || parseFloat(target.value) > 100000) {
        target.style.border = 'solid 2px red';
      } else {
        target.style.border = 'solid 2px green';
      }
      if (event.keyCode === 13) {
        event.preventDefault();
        if (target.value === '' || Number.isNaN(target.value) || parseFloat(target.value) < 0 || parseFloat(target.value) > 100000) {
          target.style.border = 'solid 2px red';
        } else {
          const newDistance: number = parseFloat(target.value);
          this.updateLine(newDistance);
          target.style.border = 'solid 2px green';
        }
      } else if (event.keyCode === 32) {
        event.preventDefault();
        return;
      }

      event.stopPropagation();
    }

    /**
     * 距離テキストボックスキーボードイベントトリガーの変更
     * @param event
     */
    downDistance = (event: KeyboardEvent) => {
      // spaceキー入力を無効化(spaceキー押下時にステージ操作を行うため)
      if (event.keyCode === 32) {
        event.preventDefault();
        return;
      }
      event.stopPropagation();
    }

    /**
     * 編集テキストボックスを非表示
     */
    switchToTextView() {
      this.textObj.style.visibility = 'visible';
      this.textboxObj.remove();
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
